export default [
  {
    path: '/Associate',
    name: 'associate',
    component: () => import('@/views/associate'),
  }
]